import { objectToArray } from '../helpers';

const state = {
  allIds: [],
  byId: {}
};

const getters = {
  find: state => id => state.byId[id],
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addCustomers: ({ commit }, customers) => {
    objectToArray(customers).forEach(c => {
      commit('add', c);
    });
  }
};

const mutations = {
  add: (state, customer) => {
    state.byId[customer.id] = customer;
    if (state.allIds.includes(customer.id)) return;
    state.allIds.push(customer.id);
  }
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
